import { AxiosPromise } from "axios";
import { cookieAuthorizedApi, BaseApi } from "ecom-teams-apps-core";
import { DictionaryDto } from "../../tasksBoard/service/api/DictionaryDto";

export interface TaskStatusesService {
    getTaskStatuses(): AxiosPromise<DictionaryDto[]>;
}

export class DefaultTaskStatusesService implements TaskStatusesService {
    private getTaskStatusesUrl: string = `/secured/dictionary?code=TASK_STATUS,CONTACT_TYPE,DIAGNOSIS,IMPLEMENTED_ACTION,DIAGNOSIS_MULTI,IMPLEMENTED_ACTION_MULTI`;

    constructor(private cookieAuthorizedApi: BaseApi) {}

    getTaskStatuses(): AxiosPromise<DictionaryDto[]> {
        return this.cookieAuthorizedApi.get<DictionaryDto[]>(this.getTaskStatusesUrl);
    }
}

export class TaskStatusesServiceWithResponse implements TaskStatusesService {
    _response: any = {
        data: this.response,
    };

    constructor(private response: any) {}

    getTaskStatuses() {
        return Promise.resolve(this._response);
    }
}

export class TaskStatusesServiceWithError implements TaskStatusesService {
    constructor(private error: any) {}

    getTaskStatuses() {
        return Promise.reject(this.error);
    }
}

export default new DefaultTaskStatusesService(cookieAuthorizedApi);
